import { request } from "../../../apis";
import { getCurrency } from "../../../plugins/utils";
const CURRENCY = getCurrency();

export const getDownlineOverview = () =>
  request("get", `/${CURRENCY}/report/agent/overview/`, {}, true, false);
